import { render, staticRenderFns } from "./destroy-req.vue?vue&type=template&id=7106acb2&scoped=true"
import script from "./destroy-req.vue?vue&type=script&lang=js"
export * from "./destroy-req.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7106acb2",
  null
  
)

export default component.exports